<template>
  <div class="welcome">
    <div class="top">Japan - China - Korea - India - Thai</div>
    <h1>
      <img id="header" alt="Asia Culture Clash" src="../assets/2025/logo-acc.png">
    </h1>
    <h3>
      Prove your culture! Collect all the eggs.
    </h3>
    <p v-if="gpsfail == true">
      Du måste godkänna GPS i din mobil för att komma vidare!
    </p>
    <button @click="approveGps" v-bind:class="(tryingGps && !gpsfail)?'button-loading':''">Godkänn GPS</button>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  emits: ["start"],
  data() {
    return { 
      tryingGps: false,
    }
  },
  props: {
    gpsfail: Boolean
  },
  methods: {
    approveGps() {
      this.tryingGps = true;
      this.$emit("start");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.welcome {
  /* background: url(../assets/2023start-bkg.jpg) no-repeat center center;
  background: url(../assets/2024/mark-hogwarts.svg) no-repeat center bottom;
  background-size: cover; */
  height: 100vh;
  background: url(../assets/2025/bkg.jpg) no-repeat center bottom;
  background-size: cover;
  padding: 0 15vw;
  text-align: left;;
}

.top {
  text-transform: uppercase;
  font-size: 3.9vw;
  text-align: center;
  padding: 5vw 0;
  text-wrap: nowrap;
  overflow: visible;;
}
#header {
  max-width: 100%;
  height: auto;
  margin: 100px 0 -0.2em -2vw;
  z-index: 20;
}
h1 {
  color: var(--color-green);
  font-size: 20vw;
}
h3 {
  font-size: 7vw;
}
p {
  font-size: 17px;
  padding: 0.5em 1em;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

button {
  margin-top: 4em;
}

.balls {
  position: absolute;
  left: 0;
  top: 0;
  width: 50vw;
  height: 60vw;
  overflow: hidden;
  pointer-events: none;
}
.balls > div {
  position: absolute;
  border-radius: 50% 50%;
  animation: 8s ease-in-out infinite ballHover;
}
.ball1 {
  left: -23vw;
  top: 6vw;
  width: 40vw;
  height: 40vw;
  background: var(--color-blue-dark);
}
.ball2 {
  left: 11vw;
  top: 4vw;
  width: 17vw;
  height: 17vw;
  background: var(--color-red);
  transform: translate(0, 3vw);
  animation-delay: 1.3s !important;
}
.ball3 {
  left: 1vw;
  top: 40vw;
  width: 12vw;
  height: 12vw;
  background: var(--color-white);
  transform: translate(0, 3vw);
  animation-delay: 2.7s !important;

}

@keyframes ballHover {
  0%, 100% {
    transform: translate(0, 3vw);
  }
  50% {
    transform: translate(0, -3vw);
  }
}


</style>
